import { InstrumentTypeEnum } from "../../../../../models/enum/instrument-type.enum";
import { DropdownItemInterface } from "../../../../../models/interfaces/dropdown-item.interface";
import { INSTRUMENT_TYPE_MAP } from "../../../../../utils/shared/constants";

const VALUES: InstrumentTypeEnum[] = ["TRANSFER", "LEASE", "HDB_MORTGAGE", "BANK_MORTGAGE", "TDM", "NOD", "TAD", "OTHERS"];

export const INSTRUMENT_DROPDOWN_OPTIONS: (Omit<DropdownItemInterface, "value"> & { value: InstrumentTypeEnum })[] = VALUES.map((value, index) => ({
  id: index,
  title: INSTRUMENT_TYPE_MAP.get(value) ?? "",
  value,
}));
